import IndustrialHowItWorks from './IndustrialHowItWorks'
export default IndustrialHowItWorks